import React from "react";
import styled, { css } from "styled-components";
import constants from "./constants";

const TableRow = styled.tr``;

export default TableRow;
